/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
import React, { CSSProperties, Component } from 'react';
import Menu from '@tencent/dui/lib/components/Menu';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import classNames from 'classnames';
import styles from '../index.css';
import { ActionType } from '../../../../editor/src/js/constants/common-action-type';
import { BorderConfigType } from '../../../../editor/src/js/constants/toolbar-data';
import i18n from '@i18next/i18n';
import { tdw } from '@tencent/tencent-doc-report';
import { TDWModuleType, TDWActionType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';

const baseMenuStyle = {
    backgroundColor: 'transparent',
    backdropFilter: 'none',
};

const customMenuStyle: CSSProperties = {
    ...baseMenuStyle,
    margin: '-8px 0',
    border: 0,
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    width: 80,
};


interface GridMenuProps {
    data: Array<any>;
    onMenuClick?: (id: number) => void;
    columns?: number;
    itemWidth?: number;
    menuStyle?: CSSProperties;
    checkSelectedValue?: boolean;
    selectedIndex?: number;
    id: string;
    menuValue: any;
    itemHeight?: number;
    itemPadding?: number;
    showBorder?: boolean;
    selectionService: ISelectionService;
}

export default class GridMenu extends Component<GridMenuProps> {
    public static defaultProps = {
        data: [],
        columns: 1,
        onMenuClick() { },
    };

    public render() {
        const { props } = this;
        const margin = this.getMargin();
        const paddingLR = this.getPaddingLR();
        const menuWidth = ((props.columns || 0) * ((props.itemWidth || 0) + (margin * 2))) + (paddingLR * 2);
        const menuStyle: CSSProperties = {
            display: 'flex', flexDirection: 'row', flexWrap: 'wrap', fontSize: '0px', width: menuWidth || 'auto', paddingLeft: paddingLR, paddingRight: paddingLR, overflowY: 'hidden', boxSizing: 'border-box',
        };// 在Mac上为auto，会出现滚动条

        // 左右居中和垂直居中选项菜单
        if (/^horizontal_/.test(props.menuValue) || /^vertical_/.test(props.menuValue) || props.id === ActionType.COLUMNS) {
            const style: CSSProperties = props.menuStyle
                ? {
                    ...customMenuStyle,
                    ...props.menuStyle,
                }
                : customMenuStyle;
            return (
                <Menu
                    onClick={this.handleMenuClick}
                    selectable={props.checkSelectedValue}
                    selectedIds={[String(props.selectedIndex)]}
                    style={style}
                >
                    {props.data?.map((itemData, i) => (itemData.tipMsg ? (
                        <Tooltip
                            key={i}
                            title={itemData.tipMsg}
                            placement={itemData.tipPlacement}
                            overlayStyle={{ zIndex: 99999 }}
                        >
                            {/* <Menu.Item id={`${i}`} key={i} style={itemStyle} className={itemClass}> */}
                            <Menu.Item id={`${i}`} key={i}>
                                {itemData.icon ? (
                                    <img src={itemData.icon}></img>
                                ) : (
                                    <div>{itemData.content || i18n.t('无')}</div>
                                )}
                            </Menu.Item>
                        </Tooltip>
                    ) : (
                        // : <Menu.Item id={`${i}`} key={i} style={itemStyle} className={itemClass}>
                        <Menu.Item id={`${i}`} key={i}>
                            {itemData.icon ? (
                                <img src={itemData.icon}></img>
                            ) : (
                                <div>{itemData.content || i18n.t('无')}</div>
                            )}
                        </Menu.Item>
                    )))}
                </Menu>
            );
        }

        return (
            <Menu style={{ ...menuStyle, ...baseMenuStyle }} onClick={this.handleMenuClick} className={styles['menu-no-shadow']}>
                {props.data?.map((itemData, i) => {
                    const itemStyle: CSSProperties = {
                        width: props.itemWidth, height: props.itemHeight, padding: props.itemPadding, margin, display: 'inline-block', boxSizing: 'border-box',
                    };
                    const itemClass = classNames({
                        [styles.menuItem]: true,
                        [styles.border]: this.props.showBorder,
                        [styles.selected]: (this.props.checkSelectedValue && this.props.selectedIndex === i)
                            || (this.props.menuValue && this.props.menuValue[itemData.id] === true),
                    });
                    const isDisabled = itemData.disabled;
                    return (
                        itemData.tipMsg
                            ? <Tooltip
                                key={i}
                                title={itemData.tipMsg}
                                placement={itemData.tipPlacement}
                                overlayStyle={{ zIndex: 99999 }}
                            >
                                <Menu.Item disabled={isDisabled} id={`${i}`} style={itemStyle} className={itemClass}>
                                    {
                                        itemData.icon
                                            ? <img style={{ width: '100%', height: '100%' }} src={itemData.icon}></img>
                                            : <div style={{ textAlign: 'center', lineHeight: `${props.itemHeight}px` }}>{itemData.content || i18n.t('无')}</div>
                                    }
                                </Menu.Item>
                            </Tooltip>
                            : <Menu.Item disabled={isDisabled} id={`${i}`} key={i} style={itemStyle} className={itemClass}>
                                {
                                    itemData.icon
                                        ? <img style={{ width: '100%', height: '100%' }} src={itemData.icon}></img>
                                        : <div style={{ textAlign: 'center', lineHeight: `${props.itemHeight}px` }}>{itemData.content || i18n.t('无')}</div>
                                }
                            </Menu.Item>
                    );
                })}
            </Menu>
        );
    }

    private handleMenuClick = (index) => {
        index = parseInt(index, 10);
        if (this.props.id === ActionType.BORDERSTYLE) {
            const itemData = this.props.data[index];
            const key = itemData.id;
            // 上报
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_TOOLBAR_FORM,
                action: TDWActionType.BORDERS,
                ver5: key,
            });
            const menuValue = { ...this.props.menuValue };
            if (BorderConfigType.BORDER_ALL === key) {
                const value = true;
                menuValue.border_horizontal = value;
                menuValue.border_vertical = value;
                menuValue.border_left = value;
                menuValue.border_bottom = value;
                menuValue.border_right = value;
                menuValue.border_top = value;
            } else if (BorderConfigType.BORDER_NONE === key) {
                const value = false;
                menuValue.border_horizontal = value;
                menuValue.border_vertical = value;
                menuValue.border_left = value;
                menuValue.border_bottom = value;
                menuValue.border_right = value;
                menuValue.border_top = value;
            } else if (BorderConfigType.BORDER_INNER === key) {
                const value = !this.props.menuValue[key];
                menuValue.border_horizontal = value;
                menuValue.border_vertical = value;
            } else if (BorderConfigType.BORDER_OUTER === key) {
                const value = !this.props.menuValue[key];
                menuValue.border_left = value;
                menuValue.border_bottom = value;
                menuValue.border_right = value;
                menuValue.border_top = value;
            } else {
                const value = !menuValue[key];
                menuValue[key] = value;
            }
            this.defineBorder(menuValue);
            const selectedModel = this.props.selectionService?.getSelectedModel();
            (selectedModel as ITableModel)?.getBorder?.()?.updateTableBorderStyle(menuValue);
        } else {
            this.props.onMenuClick?.(index);
        }
    };

    private defineBorder = (menuValue) => {
        menuValue.border_outer = menuValue.border_left
            && menuValue.border_right
            && menuValue.border_top
            && menuValue.border_bottom;
        menuValue.border_inner = menuValue.border_horizontal
            && menuValue.border_vertical;
        menuValue.border_all = menuValue.border_outer
            && menuValue.border_inner;
        menuValue.border_none = [
            'border_left',
            'border_right',
            'border_top',
            'border_bottom',
            'border_horizontal',
            'border_vertical',
        ].every(key => !menuValue[key]);
    };

    private getMargin = () => {
        if (this.props.id === ActionType.HORIZONTAL_ALIGN
            || this.props.id === ActionType.INDENT
            || this.props.id === ActionType.VERTICAL_ALIGN) {
            return 0;
        }
        return 5;
    };

    private getPaddingLR = () => {
        if (this.props.id === ActionType.HORIZONTAL_ALIGN
            || this.props.id === ActionType.INDENT
            || this.props.id === ActionType.VERTICAL_ALIGN) {
            return 0;
        }
        return 10;
    };
}
